import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// 从 localStorage 中恢复状态
const persistedState = {
  adminId: localStorage.getItem('adminId') || "",
  userName: localStorage.getItem('userName') || "",
  token: localStorage.getItem('token') || "",
  serverTime: localStorage.getItem('serverTime')
}
export default new Vuex.Store({
  state: persistedState,
  getters: {
  },
  mutations: {
    // 清除全局数据
    clearAllData(state) {
      state.adminId = ""
      state.userName = ""
      state.token = ""
      serverTime=null

      // 清除本地存储
      localStorage.removeItem('token')
      localStorage.removeItem('adminId')
      localStorage.removeItem('userName')
      localStorage.removeItem('serverTime')

    },

    // 设置token
    setToken(state, token) {
      state.token = token //存储token到vuex
      // setToken(token) //存储token到本地
      localStorage.setItem('token', token); // 存储token到本地
    },
    setServerTime(state, serverTime) {
      state.serverTime = serverTime //存储token到vuex
      // setToken(token) //存储token到本地
      localStorage.setItem('serverTime', serverTime); // 存储token到本地
    },
    setAdminId(state, adminId) {
      state.adminId = adminId
      localStorage.setItem('adminId', adminId);
    },
    setUserName(state, userName) {
      state.userName = userName
      localStorage.setItem('userName', userName);
    },
    setShopName(state, shopName) {
      state.shopName = shopName
      localStorage.setItem('shopName', shopName);
    },
    
  },
  actions: {},
  modules: {
  }
})
